import dynamic from 'next/dynamic';
import { RateCardV2Props } from './RateCardV2.types';

export const RateCardV2MGP = dynamic<RateCardV2Props>(() => import('./RateCardV2').then(module => module.RateCardV2));
